var hamburger = document.querySelector('.hamburger'),
    menu = document.querySelector('.navigation'),
    header = document.querySelector('.header'),
    body = document.body,
    languageSwitcherToggle = document.querySelectorAll('.language-switcher .current');

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
}

if (hamburger) {
    hamburger.addEventListener('click', toggleMenu);
}

if (languageSwitcherToggle) {
    languageSwitcherToggle.forEach(function (el, key) {
        el.addEventListener('click', function (e) {
            this.parentElement.classList.toggle('language-switcher--open');
            this.nextElementSibling.classList.toggle('language--open');
        });
    });
}

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        var clickableArrow = document.createElement('span');

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu').classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.insertBefore(clickableArrow, element.querySelector('.submenu'));
    }
});

//Show/hide navbar on scroll
var headerElement = document.querySelector('.header');
var c, currentScrollTop = 0;

window.onscroll = function () {
    var a = window.pageYOffset;
    var headerHeight = headerElement.offsetHeight;

    currentScrollTop = a;

    if (c < currentScrollTop && a > 5 + headerHeight) {
        headerElement.classList.add('isScrolled');
        headerElement.classList.remove('isTop');
    } else if (c > currentScrollTop && !(a <= headerHeight)) {
        headerElement.classList.remove('isScrolled');
    } else {
        headerElement.classList.add('isTop');
    }
    c = currentScrollTop;
}
